import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const DINNumberUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  dinNumber, onDinNumberChange, dinNumberError, setDinNumberError,

}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update DIN'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputTextSF type='text' name='dinNumber' label='DIN Number'
      value={dinNumber} onChange={onDinNumberChange}
      error={dinNumberError} setError={setDinNumberError}
    />

  </ModalFormUI>

export default DINNumberUpdateModalUI
